module.exports = __webpack_public_path__ + "static/media/tab_about.ad16cb3b.jpg";